<template>
  <div>
    <el-dialog top="calc(50vh - 277px)"
               :close-on-click-modal=false
               :close-on-press-escape=false
               :show-close=showCloseBtn
               width="960px"
               class="loginDialog"
               :visible.sync="curLoginDialog">
      <div class="loginDialogContainer">
        <el-row>
          <el-col :span="9"
                  :offset="14">
            <div style="width:100%;height:60px;"></div>

            <!---账号密码登录--->
            <template>
              <el-row v-show=" loginType ==='account'">
                <h2>账号密码登录</h2>
                <div style="width:100%;height:30px;"></div>
                <el-form :model="accountForm"
                         :rules="accountRules"
                         action="javascript:void(0)"
                         ref="accoutRuleForm"
                         label-width="100px"
                         class="demo-ruleForm">
                  <el-form-item prop="loginName">
                    <el-input v-model="accountForm.loginName"
                              placeholder="请输入账号"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="loginPwd">
                    <el-input placeholder="请输入密码"
                              v-model="accountForm.loginPwd"
                              show-password></el-input>
                  </el-form-item>
                  <!-- <el-form-item prop="agreeChecked">
                    <div class="agreeContainer">
                      <el-checkbox v-model="accountForm.agreeChecked"></el-checkbox>
                      登录代表您已经同意 <el-link type="primary"
                               @click="openAgreeDialog"
                               :underline="false">《用户服务协议》</el-link>和 <el-link type="primary"
                               :underline="false"
                               @click="openDisclaimerDialog">《免责声明》</el-link>
                    </div>
                  </el-form-item> -->
                  <el-form-item style="text-align:left">
                    <el-button class="loginBtn"
                               type="primary"
                               native-type="submit"
                               @click="loginByAccout">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
                  </el-form-item>
                  <el-form-item>
                    &nbsp;
                  </el-form-item>
                </el-form>
                <div style="width:100%;height:10px;"></div>
                <el-row>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('pwd')">忘记密码？&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('easy')">快捷登录/注册</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="toLoginByWechat">微信登录&nbsp;&nbsp;
                      <img src="../assets/imgs/wechatLogo.png"
                           style="position: absolute;width: 19px;top:2px" />
                    </el-link>
                  </el-col>
                </el-row>
              </el-row>
            </template>

            <!---快捷登录--->
            <template>
              <el-row v-show="loginType ==='easy'">
                <h2>快捷登录/注册</h2>
                <div style="width:100%;height:30px;"></div>
                <el-form :model="easyForm"
                         :rules="easyRules"
                         action="javascript:void(0)"
                         ref="easyRuleForm"
                         label-width="0px"
                         class="demo-ruleForm">
                  <el-form-item prop="mobile">
                    <el-input v-model="easyForm.mobile"
                              :validate-event=true
                              placeholder="请输入手机号"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="imgCaptcha">
                    <el-input placeholder="图片验证码"
                              v-model="easyForm.imgCaptcha">
                      <template slot="append"><img :src="imgCaptchaSrc"
                             class="imgCaptcha"
                             @click="changeImgCaptchaSrc"
                             alt="点击刷新" /></template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="mobileCaptcha">
                    <el-input placeholder="手机验证码"
                              v-model="easyForm.mobileCaptcha"
                              type="number">
                      <template slot="append">
                        <el-link type="primary"
                                 :underline="false"
                                 :disabled="mobileMsgSending"
                                 @click="sendMobileMsgByLogin">{{mobileMsgBtnText}}</el-link>
                      </template>
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item prop="agreeChecked">
                    <div class="agreeContainer">
                      <el-checkbox v-model="easyForm.agreeChecked"></el-checkbox>
                      登录代表您已经同意 <el-link type="primary"
                               :underline="false"
                               @click="openAgreeDialog">《用户服务协议》</el-link>和 <el-link type="primary"
                               :underline="false"
                               @click="openDisclaimerDialog">《免责声明》</el-link>
                    </div>
                  </el-form-item> -->
                  <el-form-item style="text-align:left">
                    <el-button class="loginBtn"
                               type="primary"
                               native-type="submit"
                               @click="loginByEasy">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
                  </el-form-item>
                </el-form>
                <div style="width:100%;height:10px;"></div>
                <el-row>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('pwd')">忘记密码？&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('account')">账号密码登录</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="toLoginByWechat">微信登录&nbsp;
                      <img src="../assets/imgs/wechatLogo.png"
                           style="position: absolute;    width: 21px;" />
                    </el-link>
                  </el-col>
                </el-row>
              </el-row>
            </template>

            <!---重置密码--->
            <template>
              <el-row v-show="loginType=='pwd'">
                <h2>找回密码</h2>
                <div style="width:100%;height:30px;"></div>
                <el-form :model="pwdForm"
                         :rules="pwdRules"
                         action="javascript:void(0)"
                         ref="pwdRuleForm"
                         label-width="0px"
                         class="demo-ruleForm">
                  <el-form-item prop="mobile">
                    <el-input v-model="pwdForm.mobile"
                              placeholder="请输入手机号"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="imgCaptcha">
                    <el-input placeholder="图片验证码"
                              v-model="pwdForm.imgCaptcha">
                      <template slot="append"><img :src="imgCaptchaSrc"
                             class="imgCaptcha"
                             @click="changeImgCaptchaSrc"
                             alt="点击刷新" /></template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="mobileCaptcha">
                    <el-input placeholder="手机验证码"
                              v-model="pwdForm.mobileCaptcha"
                              type="number">
                      <template slot="append">
                        <el-link type="primary"
                                 :underline="false"
                                 :disabled="mobileMsgSending"
                                 @click="sendMobileMsgByPwd">{{mobileMsgBtnText}}</el-link>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="newPwd">
                    <el-input placeholder="新密码"
                              v-model="pwdForm.newPwd"
                              show-password>
                    </el-input>
                  </el-form-item>
                  <el-form-item style="text-align:left">
                    <el-button class="loginBtn"
                               type="primary"
                               native-type="submit"
                               @click="toResetPwd">重置密码</el-button>
                  </el-form-item>
                </el-form>
                <div style="width:100%;height:10px;"></div>
                <el-row>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('easy')">快捷登录/注册</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('account')">账号密码登录</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="toLoginByWechat">微信登录&nbsp;
                      <img src="../assets/imgs/wechatLogo.png"
                           style="position: absolute;    width: 21px;" />
                    </el-link>
                  </el-col>
                </el-row>

              </el-row>
            </template>
            <template>
              <el-row v-show="loginType=='wechat'">
                <iframe :src="wechatLoginUrl"
                        style="width: 299px;height: 400px;border: none;"
                        security="restricted">
                </iframe>
                <div style="width:100%;height:10px;"></div>
                <el-row>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('easy')">快捷登录/注册</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('account')">账号密码登录</el-link>
                  </el-col>
                  <el-col :span="8">
                    <el-link :underline="false"
                             @click="changeLoginType('pwd')">忘记密码？&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-link>
                  </el-col>
                </el-row>
              </el-row>

            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog title="服务协议"
               :visible.sync="agreeDialogVisible"
               top="5vh"
               width="80%">
      <agree />
    </el-dialog>
    <el-dialog title="免责声明"
               :visible.sync="disclaimerDialogVisible"
               top="5vh"
               width="80%">
      <disclaimer />
    </el-dialog>
  </div>
</template>
<script>
import agree from './agree'
import disclaimer from './disclaimer'
import Loading from '../components/js/Loading.vue'
export default {
  components: {
    agree,
    disclaimer
  },
  props: ['canClose'],
  name: 'login',
  data: function () {
    return {
      wechatLoginUrl: '',
      curLoginDialog: true,
      agreeDialogVisible: false,
      disclaimerDialogVisible: false,
      showCloseBtn: false,
      accountForm: {
        loginName: '',
        loginPwd: '',
        agreeChecked: true
      },
      accountRules: {
        loginName: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        loginPwd: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
          // { min: 6, message: '密码长度不小于6位', trigger: 'blur' }
        ]
      },
      loginType: 'easy',
      imgCaptchaSrc: '',
      mobileMsgSending: false,
      mobileMsgBtnText: '发送验证码',
      easyForm: {
        mobile: '',
        imgCaptcha: '',
        mobileCaptcha: ' ',
        agreeChecked: true
      },
      easyRules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
          // { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' }
          // { pattern: /\d{4}$/, message: '图片验证码格式错误', trigger: 'blur' }
        ],
        mobileCaptcha: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' }
          // { pattern: /\d{6}$/, message: '短信验证码格式错误', trigger: 'blur' }
        ]
      },
      pwdForm: {
        mobile: '',
        imgCaptcha: '',
        mobileCaptcha: ' ',
        newPwd: ''
      },
      pwdRules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
          // { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' }
          // { pattern: /\d{4}$/, message: '图片验证码格式错误', trigger: 'blur' }
        ],
        mobileCaptcha: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' }
          // { pattern: /\d{6}$/, message: '短信验证码格式错误', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
          // { min: 6, message: '密码长度不小于6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    changeLoginType (val) {
      this.loginType = val

      if (this.$refs['accoutRuleForm']) {
        this.$refs['accoutRuleForm'].resetFields()
      }
      if (this.$refs['easyRuleForm']) {
        this.$refs['easyRuleForm'].resetFields()
      }
      if (this.$refs['pwdRuleForm']) {
        this.$refs['pwdRuleForm'].resetFields()
      }
      this.$forceUpdate()
    },
    openDisclaimerDialog () {
      this.disclaimerDialogVisible = true
    },
    openAgreeDialog () {
      this.agreeDialogVisible = true
    },
    async loginByAccout () { // 账户登录
      let _this = this
      if (!this.accountForm.agreeChecked) {
        this.$message.error('对不起，您没有同意《用户服务协议》和 《免责声明》')
        return
      }
      this.$refs.accoutRuleForm.validate((valid) => {
        if (valid) {
          _this.axios.post('/webApi/v3/doLogin', this.accountForm).then((response) => {
            if (response) {
              localStorage.setItem('userInfo', JSON.stringify(response.data))
              if (window.parent) {
                window.open(window.parent.location.href, '_top')
              }
              window.location.reload()
            }
          })
        }
      })
    },
    changeImgCaptchaSrc () { // 更换验证吗
      this.imgCaptchaSrc = '/webApi/v3/captcha/imgCaptcha?' + Math.random()
    },
    sendMobileMsgByPwd () { // 重置密码发送验证码
      this.sendMobileMsg(this.pwdForm)
    },
    sendMobileMsgByLogin () { // 快捷登录发送验证码
      this.sendMobileMsg(this.easyForm)
    },
    sendMobileMsg (form) { // 发送短信验证码
      Loading.silentLoading()
      let _this = this
      let remaindTime = 60
      this.mobileMsgSending = true
      let timer = setInterval(() => {
        _this.mobileMsgBtnText = remaindTime + ' S'
        remaindTime--
        if (remaindTime <= 0) {
          clearInterval(timer)
          _this.mobileMsgSending = false
          _this.mobileMsgBtnText = '发送验证码'
        }
      }, 1000)

      this.axios.post('/webApi/v3/captcha/mobileCaptcha', form).then((response) => {
        _this.$message({
          message: '短信验证码发送成功',
          type: 'success'
        })
      }).catch(e => {
        _this.$message.error('短信验证码发送失败')
        clearInterval(timer)
        _this.mobileMsgSending = false
        _this.mobileMsgBtnText = '发送验证码'
      })
    },
    // 快捷登录
    loginByEasy () {
      if (!this.easyForm.agreeChecked) {
        this.$message.error('对不起，您没有同意《用户服务协议》和 《免责声明》')
        return
      }
      this.$refs.easyRuleForm.validate((valid) => {
        if (valid) {
          this.axios.post('/webApi/v3/easyLogin', this.easyForm).then((response) => {
            if (response) {
              localStorage.setItem('userInfo', JSON.stringify(response.data))
              if (window.parent) {
                window.open(window.parent.location.href, '_top')
              }
              window.location.reload()
            }
          })
        }
      })
    },
    // 忘记密码
    toResetPwd () {
      let _this = this
      this.$refs.pwdRuleForm.validate((valid) => {
        if (valid) {
          this.axios.post('/webApi/v3/resetPwd', this.pwdForm).then((response) => {
            _this.$message({
              message: '密码重置成功，请使用新密码登录',
              type: 'success'
            })
            _this.loginType = 'account'
            _this.$refs['accoutRuleForm'].resetFields()
          })
        }
      })
    },
    toLoginByWechat () { // 微信登录
      let _this = this
      let tempUrl = window.parent.location.href
      this.changeLoginType('wechat')
      this.axios.get('/webApi/v3/wechat/authUrl?from=' + encodeURIComponent(tempUrl)).then((response) => {
        _this.wechatLoginUrl = response.data
        // window.open(response.data, '_top')
      })
    }
  },
  computed: {
    loginDialog () {
      return this.$store.state.loginDialogVisible
    }
  },
  watch: {
    loginDialog: function () {
      this.curLoginDialog = true
    }
  },
  mounted () {
    this.changeImgCaptchaSrc()
    if (this.canClose) {
      this.showCloseBtn = true
    }
  }
}

</script>
<style lang="less" scoped>
</style>
<style lang="less">
@import '../assets/css/index.less';
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}
.loginBtn {
  width: 186px;
}
.loginDialog {
  background-color: rgba(0, 0, 0, 0);
  border: 0px;
  box-shadow: none;
  padding: 0px;
  .el-dialog {
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 0 !important;
  }
  .el-dialog__body {
    padding: 0px;
    background-color: rgba(0, 0, 0, 0);
  }
  .el-dialog__header {
    height: 0px !important;
    padding: 0px !important;
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
}
.loginDialogContainer {
  width: 960px;
  height: 554px;
  background-image: url('../assets/imgs/loginDialogBg.png');
  background-size: 100%;
  .agreeContainer {
    color: #999;
    text-align: left;
    font-size: 0.8em;
    .el-checkbox {
      margin: 0px;
    }
  }
  .el-link.el-link--primary {
    color: #66b1ff;
  }
  .el-link.el-link--primary:hover {
    color: #66b1ff;
  }
  .el-input__inner {
    border-radius: 0px;
    border: 0px;
    border-bottom: 1px solid #dcdfe6;
    background-color: rgba(0, 0, 0, 0);
  }
  .el-form-item__content {
    margin-left: 0px !important;
  }
  .el-input-group__append {
    border-radius: 0px;
    border: 0px;
    background-color: rgba(0, 0, 0, 0);
    padding: 0px;
    border-bottom: 1px solid #dcdfe6;
  }
  .imgCaptcha {
    width: 100px;
    max-width: 100px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/login.vue